/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPermissionCatalogResponse,
  GetRolePermissionGrantsResponse,
  GetRolesResponse,
  SetRolePermissionGrantRequest
} from '.././schemas';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';




export const cspReport = (
    cspReportBody: unknown,
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/csp-report`, method: 'POST',
      headers: {'Content-Type': 'application/csp-report', },
      data: cspReportBody, signal
    },
      );
    }
  


export const getCspReportMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cspReport>>, TError,{data: unknown}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cspReport>>, TError,{data: unknown}, TContext> => {

const mutationKey = ['cspReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cspReport>>, {data: unknown}> = (props) => {
          const {data} = props ?? {};

          return  cspReport(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CspReportMutationResult = NonNullable<Awaited<ReturnType<typeof cspReport>>>
    export type CspReportMutationBody = unknown
    export type CspReportMutationError = ErrorType<unknown>

    export const useCspReport = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cspReport>>, TError,{data: unknown}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cspReport>>,
        TError,
        {data: unknown},
        TContext
      > => {

      const mutationOptions = getCspReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getPermissionCatalog = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetPermissionCatalogResponse>(
      {url: `/api/security/permission-catalog`, method: 'GET', signal
    },
      );
    }
  



export const getGetPermissionCatalogQueryKey = () => {
    return [
    `/api/security/permission-catalog`
    ] as const;
    }

    
export const getGetPermissionCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionCatalog>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionCatalog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionCatalogQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionCatalog>>> = ({ signal }) => getPermissionCatalog(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionCatalog>>>
export type GetPermissionCatalogQueryError = ErrorType<unknown>


export function useGetPermissionCatalog<TData = Awaited<ReturnType<typeof getPermissionCatalog>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionCatalog>>,
          TError,
          Awaited<ReturnType<typeof getPermissionCatalog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionCatalog<TData = Awaited<ReturnType<typeof getPermissionCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionCatalog>>,
          TError,
          Awaited<ReturnType<typeof getPermissionCatalog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionCatalog<TData = Awaited<ReturnType<typeof getPermissionCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPermissionCatalog<TData = Awaited<ReturnType<typeof getPermissionCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSecurityRoles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRolesResponse>(
      {url: `/api/security/roles`, method: 'GET', signal
    },
      );
    }
  



export const getGetSecurityRolesQueryKey = () => {
    return [
    `/api/security/roles`
    ] as const;
    }

    
export const getGetSecurityRolesQueryOptions = <TData = Awaited<ReturnType<typeof getSecurityRoles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityRoles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSecurityRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSecurityRoles>>> = ({ signal }) => getSecurityRoles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSecurityRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSecurityRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getSecurityRoles>>>
export type GetSecurityRolesQueryError = ErrorType<unknown>


export function useGetSecurityRoles<TData = Awaited<ReturnType<typeof getSecurityRoles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecurityRoles>>,
          TError,
          Awaited<ReturnType<typeof getSecurityRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSecurityRoles<TData = Awaited<ReturnType<typeof getSecurityRoles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSecurityRoles>>,
          TError,
          Awaited<ReturnType<typeof getSecurityRoles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSecurityRoles<TData = Awaited<ReturnType<typeof getSecurityRoles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityRoles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSecurityRoles<TData = Awaited<ReturnType<typeof getSecurityRoles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSecurityRoles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSecurityRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const setRolePermissionGrant = (
    roleId: number,
    setRolePermissionGrantRequest: SetRolePermissionGrantRequest,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/security/roles/${roleId}/permission-grants`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setRolePermissionGrantRequest
    },
      );
    }
  


export const getSetRolePermissionGrantMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRolePermissionGrant>>, TError,{roleId: number;data: SetRolePermissionGrantRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setRolePermissionGrant>>, TError,{roleId: number;data: SetRolePermissionGrantRequest}, TContext> => {

const mutationKey = ['setRolePermissionGrant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRolePermissionGrant>>, {roleId: number;data: SetRolePermissionGrantRequest}> = (props) => {
          const {roleId,data} = props ?? {};

          return  setRolePermissionGrant(roleId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetRolePermissionGrantMutationResult = NonNullable<Awaited<ReturnType<typeof setRolePermissionGrant>>>
    export type SetRolePermissionGrantMutationBody = SetRolePermissionGrantRequest
    export type SetRolePermissionGrantMutationError = ErrorType<unknown>

    export const useSetRolePermissionGrant = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRolePermissionGrant>>, TError,{roleId: number;data: SetRolePermissionGrantRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setRolePermissionGrant>>,
        TError,
        {roleId: number;data: SetRolePermissionGrantRequest},
        TContext
      > => {

      const mutationOptions = getSetRolePermissionGrantMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getRolePermissionGrants = (
    roleId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetRolePermissionGrantsResponse>(
      {url: `/api/security/roles/${roleId}/permission-grants`, method: 'GET', signal
    },
      );
    }
  



export const getGetRolePermissionGrantsQueryKey = (roleId?: number,) => {
    return [
    `/api/security/roles/${roleId}/permission-grants`
    ] as const;
    }

    
export const getGetRolePermissionGrantsQueryOptions = <TData = Awaited<ReturnType<typeof getRolePermissionGrants>>, TError = ErrorType<unknown>>(roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolePermissionGrants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolePermissionGrantsQueryKey(roleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRolePermissionGrants>>> = ({ signal }) => getRolePermissionGrants(roleId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(roleId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRolePermissionGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRolePermissionGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof getRolePermissionGrants>>>
export type GetRolePermissionGrantsQueryError = ErrorType<unknown>


export function useGetRolePermissionGrants<TData = Awaited<ReturnType<typeof getRolePermissionGrants>>, TError = ErrorType<unknown>>(
 roleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolePermissionGrants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolePermissionGrants>>,
          TError,
          Awaited<ReturnType<typeof getRolePermissionGrants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRolePermissionGrants<TData = Awaited<ReturnType<typeof getRolePermissionGrants>>, TError = ErrorType<unknown>>(
 roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolePermissionGrants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolePermissionGrants>>,
          TError,
          Awaited<ReturnType<typeof getRolePermissionGrants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRolePermissionGrants<TData = Awaited<ReturnType<typeof getRolePermissionGrants>>, TError = ErrorType<unknown>>(
 roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolePermissionGrants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRolePermissionGrants<TData = Awaited<ReturnType<typeof getRolePermissionGrants>>, TError = ErrorType<unknown>>(
 roleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolePermissionGrants>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRolePermissionGrantsQueryOptions(roleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




